import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';

export interface  ColourPartialCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
}

export class ColourPartialCheckout extends React.Component<ColourPartialCheckoutProps, any> {
  public render() {
    return this.configuration && this.configuration.surface ? (
      <div className="colour-partial-line">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.surfaceTitle} />
        </span>
        <ul>
          {this.configuration.surface.color && (
            <li>
              <FormattedMessage {...MESSAGES.surfaceColor} values={{
                color: formatMessage({...MESSAGES[this.configuration.surface.color]})
              }} />
            </li>
          )}
          {this.configuration.surface.gelCoat && (
            <li>
              <FormattedMessage {...MESSAGES.surfaceGelCoat} />
            </li>
          )}
        </ul>
      </div>
    ) : null;
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const ColourPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(ColourPartialCheckout);

export default ColourPartialCheckoutComponent;